export default defineAppConfig({
  colorMode: {
    preference: 'light',
    fallback: 'light',
    classSuffix: ''
  },
  ui: {
    dropdown: {
      container: 'relative',
      trigger: 'flex items-center',
      background: 'bg-white',
      rounded: 'rounded-lg',
      shadow: 'shadow-lg',
      ring: 'ring-1 ring-gray-200',
      base: 'relative focus:outline-none overflow-hidden',
      item: {
        base: 'group relative flex items-center gap-2 w-full px-3 py-2 text-gray-700 transition-colors duration-150',
        rounded: 'rounded-md',
        padding: 'px-3 py-2',
        size: 'text-sm',
        active: 'text-green-600 bg-green-50',
        inactive: 'text-gray-700',
        hover: 'hover:text-green-600 hover:bg-green-50',
        icon: {
          base: 'flex-shrink-0 w-5 h-5',
          active: 'text-green-500',
          inactive: 'text-gray-400'
        },
        avatar: {
          base: 'flex-shrink-0',
          size: '2xs'
        },
        label: 'truncate',
      }
    },
    formGroup: {
      label: {
        base: '!dark:text-gray-700'
      }
    }
  }
}) 